const container = {
  position: "relative",
  marginTop: 16,
};

const accordionItem = {
  justifyContent: "space-between",
  alignItems: "left",
  border: "1px solid",
  borderColor: "primary.20",
  borderRadius: "small",
  padding: "8px",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "primary.20",
  },
};

const content = {
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  paddingRight: "8px",
};

const title = {
  marginRight: "auto",
};

const description = {
  overflow: "hidden",
};

const leftSideContainer = {
  flexShrink: 0,
  alignSelf: "flex-left",
  display: "flex",
  gap: "17px",
  paddingLeft: "8px",
  paddingRight: "9.47px",
};

const leftSideCell = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const leftSideCellIcon = {
  display: "flex",
  flexShrink: 0,
  alignSelf: "flex-start",
};

const uiActionIcon = {
  width: 16,
  height: 16,
};

const cellContainer = {
  flexShrink: 0,
  alignSelf: "flex-right",
  display: "flex",
  gap: "8px",
};

const cell = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flex: 1,
  width: 135,
  borderRadius: "2px",
};

const cellBasic = {
  ...cell,
  backgroundColor: "neutral.10",
};

const cellPrime = {
  ...cell,
  backgroundColor: "primary.20",
};

const cellIcon = {
  width: "16.67px",
  height: "16.67px",
};

export default {
  container,
  content,
  title,
  description,
  leftSideContainer,
  leftSideCell,
  leftSideCellIcon,
  uiActionIcon,
  accordionItem,
  cellContainer,
  cellBasic,
  cellPrime,
  cellIcon,
};
